import * as yup from 'yup';
import ddt from '@wix/da-ddt';

const gallectionSearchSchema = yup.object({
  type: yup
    .string()
    .oneOf(['gallery', 'collection', 'private_collection'])
    .required('Gallection type is required'),
  order: yup
    .string()
    .oneOf(['most-recent', 'popular'])
    .optional(),
  q: yup
    .string()
    .required('Search query is required'),
  username: yup
    .string()
    .required('Username is required'),
  offset: yup
    .number()
    .min(0, 'Offset must be at least 0')
    .max(50000, 'Offset must be at most 50000')
    .optional(),
  limit: yup
    .number()
    .min(1, 'Limit must be at least 1')
    .max(120, 'Limit must be at most 120')
    .optional(),
  init: yup
    .boolean()
    .optional(),
});

/**
 * Validates gallection search request data against the server's expected schema
 * @param data The request data to validate
 * @returns boolean indicating if the data is valid
 */
export function validateGallectionSearchRequest(data: any): boolean {
  try {
    gallectionSearchSchema.validateSync(data);
    return true;
  } catch (error) {
    ddt.log('gallection-search-validation', 'Validation failed', {
      data,
      error: error.message,
      path: error.path,
    });
    return false;
  }
}
